import axios from 'axios';
import store from '../store';
import { useMemoize } from '@vueuse/core';

axios.defaults.baseURL = "/api";
axios.defaults.withCredentials = true;

// Add a request interceptor
axios.interceptors.request.use(function (config) {

    //store.commit("commStore/setServerCallCount", 1);    

    //헤더 설정
    config.timeout = 3000000;

    config.headers['Accept'] = 'application/json;';
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
    }
    config.headers['Access-Control-Allow-Origin'] = '*';

    return config;

}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Refresh Token 요청을 위한 별도 axios 인스턴스 (인터셉터 재귀 방지)
const refreshAxios = axios.create({
    baseURL: axios.defaults.baseURL,
    withCredentials: true
});

//Refresh Token 발급 시간
let refreshTokenIssueTime = null;

//Refresh Token 발급 (memoization 처리: 중복 요청 방지)
const getRefreshToken = useMemoize(
    async () => {
        refreshTokenIssueTime = new Date();

        // refreshAxios 사용 (쿠키가 자동 전송됨)
        const response = await refreshAxios.post('/auth/refresh/token');

        return response;
    }
)

axios.interceptors.response.use(
    (res) => {
        store.commit("commStore/setServerCallCount", -1);
        return res;
    },
    async (err) => {

        store.commit("commStore/setServerCallCount", -1);

        const originalConfig = err.config;

        if (err.response) {

            // Access Token was expired (401)
            // originalConfig.url !== '/auth/refresh/token' check to avoid loops if refreshAxios wasn't used
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;

                try {

                    if (refreshTokenIssueTime) {
                        let difference = (new Date() - refreshTokenIssueTime) / 1000;
                        //토큰 재발급후 2초 초과시 발급 메소드 memoization 해지
                        if (difference > 2) {
                            getRefreshToken.clear();
                            refreshTokenIssueTime = null;
                        }
                    }

                    const response = await getRefreshToken();

                    if (response.data.status === 'success') {
                        // 기존 요청에 새 토큰(쿠키) 반영하여 재시도
                        return axios(originalConfig);
                    } else {
                        //로그아웃 처리                  
                        store.commit("commStore/clearServerCallCount");
                        localStorage.removeItem("draco-user-id");
                        localStorage.removeItem("draco-user-name");
                        localStorage.removeItem("draco-authrt-id");
                        location.href = '/login';
                    }

                } catch (_error) {
                    store.commit("commStore/clearServerCallCount");
                    localStorage.removeItem("draco-user-id");
                    localStorage.removeItem("draco-user-name");
                    localStorage.removeItem("draco-authrt-id");
                    location.href = '/login';
                    return Promise.reject(_error);
                }
            } else if (err.response.status === 500) {
                alert("시스템 오류 입니다. 관리자 에게 문의 하세요.");
            } else if (err.response.status === 403) {
                alert("권한이 없습니다.");
            }
        }

        return Promise.reject(err);
    }
);

export default axios;